import { useRouter } from '@capsicum/common-web';
import { useState } from 'react';

import { RecoveryKitGenerated } from '../../ui';

import { NCWalletRecoveryForm } from './NCWalletRecoveryForm';

export const NCWalletRecovery = () => {
	const [newRecoveryKit, setNewRecoveryKit] = useState<
		| {
				credentialId: string;
				secret: string;
		  }
		| undefined
	>();

	const { replace } = useRouter();

	if (newRecoveryKit) {
		return (
			<RecoveryKitGenerated
				code={newRecoveryKit.secret}
				isReplacementKitAfterRecovery
				keyId={newRecoveryKit.credentialId}
				testIDPrefix="walletRecoveryCompleted"
				onAccept={() => replace('/')}
			/>
		);
	}

	return <NCWalletRecoveryForm onCompletedRecovery={setNewRecoveryKit} />;
};
